import { render, staticRenderFns } from "./ModalProtocolFilter.vue?vue&type=template&id=9d5fd792&scoped=true&"
import script from "./ModalProtocolFilter.vue?vue&type=script&lang=js&"
export * from "./ModalProtocolFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5fd792",
  null
  
)

export default component.exports